/* Auto Generated */

export enum ImagePosition {
	left,
	right,
}
